<template>
	<v-tab-item>
		<v-sheet elevation="0" class="pa-2">
			<v-row no-gutters class="mt-2" justify="space-between">
				<h3 class="text-h6 font-weight-bold">ゴム生地使用企業一覧</h3>
				<v-btn class="ma-1" @click="showNewDialog = true" dense dark color="secondary">
					<v-icon class="mr-2">mdi-plus</v-icon>
					作成する
				</v-btn>
			</v-row>
			<p class="mt-4">ゴム生地名 : {{ rubber.name }}</p>
			<div class="table-container mt-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="customer_companies"
					item-key="name"
					class="elevation-1"
					:mobile-breakpoint="240"
					disable-filtering
					disable-pagination
					disable-sort
					hide-default-footer
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="clickable">
							<td>{{ item.name }}</td>
							<td>{{ item.customer_code }}</td>
							<td>{{ item.industry ? item.industry.name : "" }}</td>
							<td>
								<template v-for="(tag, i) in item.customer_company_tags">
									<span :key="i">
										{{ tag.name }}
									</span>
								</template>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-sheet>

		<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		<RubberCustomerCompanyNewDialog
			:dialog.sync="showNewDialog"
			:rubber="rubber"
			@create="setItems($event)"
		/>
	</v-tab-item>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import PaginationModule from "../../shared/PaginationModule.vue"
import RubberCustomerCompanyNewDialog from "../components/RubberCustomerCompanyNewDialog.vue"

export default {
	props: {
		rubber: {
			type: Object,
			default: false,
		},
		isFetched: {
			type: Boolean,
		},
	},
	components: {
		PaginationModule,
		RubberCustomerCompanyNewDialog,
	},
	data() {
		return {
			headers: [
				{ text: "顧客企業名", value: "name", width: "200px" },
				{ text: "得意先コード", value: "customer_code", width: "200px" },
				{ text: "業種", value: "industry_name", width: "150px" },
				{ text: "タグ名", value: "customer_company_tags_name", width: "300px" },
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			customer_companies: [],
			showNewDialog: false,
		}
	},
	// TODO 削除追加
	methods: {
		setItems(customer_company) {
			this.customer_companies.push(customer_company)
		},
		fetchRubberCustomerCompanies(i) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubber/rubber_customer_companies/${this.rubber.id}`
			axios
				.get(url, {
					headers,
					params: {
						page: i,
					},
				})
				.then((res) => {
					this.customer_companies = res.data.customer_companies
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setOrderPaints(matterProducts, orderPaints) {
			this.matterProducts = matterProducts.map((m) => {
				m.order_paints = orderPaints[m.product_id]
				return m
			})
		},
		getPage(i) {
			this.fetchRubberCustomerCompanies(i)
			const elements = document.getElementsByClassName("v-dialog--active")
			if (!elements || !elements.length) {
				return
			}
			elements[0].scrollTop = 0
		},
	},
	watch: {
		isFetched(newVal, oldVal) {
			if (oldVal == false && newVal == true) {
				this.fetchRubberCustomerCompanies(1)
			} else if (oldVal == true && newVal == false) {
			}
		},
		deep: true,
	},
}
</script>

<style scoped lang="scss">
.table-container {
	td {
		cursor: auto !important;
	}
}
</style>
